import React, { useState } from "react";
import ArticleTag from "../ArticleTag/ArticleTag";
import LinkWithLanguage from "../LinkWithLanguage/LinkWithLanguage";
import "./ArticleCard.css";
import TEXT_MISC from "../../../utils/text/misc.json";

export default function ArticleCard({
  title,
  author,
  date,
  tags,
  code,
  description,
  articleURL,
  imageURL,
  imageAltText,
  isLinkInternal,
  language,
}) {
  const [defaultImage] = useState("images/backgroundDefault.jpeg");

  return (
    <div className="ac-container">
      <div className="ac-image-container">
        <img
          className="ac-image"
          src={"images/" + (imageURL ? imageURL + ".png" : defaultImage)}
          alt={imageAltText}
          onError={(event) => {
            event.target.src = "images/backgroundDefault.jpeg";
            event.onerror = null;
          }}
        />
      </div>
      <div className="ac-content">
        {date === "" && tags.length === 0 ? null : (
          <div className="ac-meta">
            <div className="ac-date">
              <span className="ac-date-text">{date}</span>
            </div>
            <div className="ac-tags">
              {tags.map((tag, key) => (
                <ArticleTag key={key} text={tag} />
              ))}
            </div>
          </div>
        )}
        <div className="ac-text">
          <h1 className="ac-title">{title}</h1>
          <p className="ac-author">{author}</p>
          {/* <div className="ac-description">
            <p>{description}</p>
          </div> */}

          {isLinkInternal ? (
            <LinkWithLanguage
              to={"/publicacion/" + code}
              className="ac-read-more"
              content={TEXT_MISC["seeMore"][language]}
              href="#"
            />
          ) : (
            <a
              href={articleURL}
              className="ac-read-more"
              target={"_blank"}
              rel="noreferrer"
            >
              {TEXT_MISC["seeMore"][language]}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
